// cspell:disable

/**
 * Carrier registry - the source of truth for supported carriers.
 */
import {
  CarrierDefinition,
  requiresEasypostCredentials,
} from "./carrier-definition";
import { SupportedCarrier } from "./supported-carrier";
import { TrackingProvider } from "./tracking-provider";

const _carrierRegistry = {
  [SupportedCarrier.FOUR_PX]: {
    carrier: SupportedCarrier.FOUR_PX,
    displayName: "4PX",
    slug: "four_px",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "4px",
    },
    trackingUrl: (trackingCode) =>
      `https://track.4px.com/#/result/0/${trackingCode}`,
  },
  [SupportedCarrier.AAA_COOPER_TRANSPORTATION]: {
    carrier: SupportedCarrier.AAA_COOPER_TRANSPORTATION,
    displayName: "AAA Cooper Transportation",
    slug: "aaa_cooper_transportation",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "aaa-cooper-transportation",
    },
    trackingUrl: () => "https://www.aaacooper.com/",
  },
  [SupportedCarrier.ACI_LOGISTIX]: {
    carrier: SupportedCarrier.ACI_LOGISTIX,
    displayName: "ACI Logistix",
    slug: "aci_logistix",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "aci-logistix",
    },
    trackingUrl: (trackingCode) =>
      `https://www.acilogistix.com/track-my-parcel/?TrackingID=${trackingCode}`,
  },
  [SupportedCarrier.AIRTERRA]: {
    carrier: SupportedCarrier.AIRTERRA,
    displayName: "AirTerra",
    slug: "airterra",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "airterra",
    },
    trackingUrl: (trackingCode) =>
      `https://www.quietplatforms.com/tracking/${trackingCode}`,
  },
  [SupportedCarrier.AMAZON]: {
    carrier: SupportedCarrier.AMAZON,
    displayName: "Amazon",
    slug: "amazon",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "amazon-shipping-amazon-mcf",
    },
    trackingUrl: (trackingCode) =>
      `https://track.amazon.com/tracking/${trackingCode}?trackingId=${trackingCode}`,
  },
  [SupportedCarrier.AMAZON_IN]: {
    carrier: SupportedCarrier.AMAZON_IN,
    displayName: "Amazon Shipping (IN)",
    slug: "amazon_in",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "amazon_in",
    },
    trackingUrl: (trackingCode) =>
      `https://track.amazon.in/tracking/${trackingCode}?trackingId=${trackingCode}`,
  },
  [SupportedCarrier.AMAZON_IT]: {
    carrier: SupportedCarrier.AMAZON_IT,
    displayName: "Amazon Shipping (IT)",
    slug: "amazon_it",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "amazon_it",
    },
    trackingUrl: (trackingCode) =>
      `https://track.amazon.it/tracking/${trackingCode}?trackingId=${trackingCode}`,
  },
  [SupportedCarrier.AMAZON_UK]: {
    carrier: SupportedCarrier.AMAZON_UK,
    displayName: "Amazon Shipping (UK)",
    slug: "amazon_uk",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "amazon_uk",
    },
    trackingUrl: (trackingCode) =>
      `https://track.amazon.co.uk/tracking/${trackingCode}?trackingId=${trackingCode}`,
  },
  [SupportedCarrier.AN_POST]: {
    carrier: SupportedCarrier.AN_POST,
    displayName: "An Post",
    slug: "an_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "an-post",
    },
    trackingUrl: (trackingCode) =>
      `https://www.anpost.com/Post-Parcels/Track/History?item=${trackingCode}`,
  },
  [SupportedCarrier.APC_POSTAL_LOGISTICS]: {
    carrier: SupportedCarrier.APC_POSTAL_LOGISTICS,
    displayName: "APC Postal Logistics",
    slug: "apc_postal_logistics",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Apc",
    },
    trackingUrl: (trackingCode) =>
      `https://www.apc-pli.com/apc-tracking-v2.html?id=${trackingCode}`,
  },
  [SupportedCarrier.APG_ECOMMERCE]: {
    carrier: SupportedCarrier.APG_ECOMMERCE,
    displayName: "APG eCommerce",
    slug: "apg_ecommerce",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "apg",
    },
  },
  [SupportedCarrier.ARAMEX]: {
    carrier: SupportedCarrier.ARAMEX,
    displayName: "Aramex",
    slug: "aramex",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "aramex",
    },
    trackingUrl: (trackingCode) =>
      `https://www.aramex.com/us/en/track/track-results-new?type=EXP&ShipmentNumber=${trackingCode}`,
  },
  [SupportedCarrier.ARAMEX_AU]: {
    carrier: SupportedCarrier.ARAMEX_AU,
    displayName: "Aramex AU",
    slug: "aramex_au",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "aramex-au",
    },
    trackingUrl: (trackingCode) =>
      `https://www.aramex.com/au/en/track/track-results-new?type=EXP&ShipmentNumber=${trackingCode}`,
  },
  [SupportedCarrier.ARAMEX_NZ]: {
    carrier: SupportedCarrier.ARAMEX_NZ,
    displayName: "Aramex NZ",
    slug: "aramex_nz",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "aramex-nz",
    },
    trackingUrl: (trackingCode) =>
      `https://www.aramex.com/nz/en/track/track-results-new?type=EXP&ShipmentNumber=${trackingCode}`,
  },
  [SupportedCarrier.ARC_BEST]: {
    carrier: SupportedCarrier.ARC_BEST,
    displayName: "ArcBest",
    slug: "arc_best",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "arcbest-panther",
    },
    trackingUrl: (trackingCode) =>
      `https://view.arcb.com/nlo/tools/tracking/${trackingCode}`,
  },
  // asendia: use asendia_usa instead (asendiausa works better in Track123)
  [SupportedCarrier.ASENDIA_USA]: {
    carrier: SupportedCarrier.ASENDIA_USA,
    displayName: "Asendia USA",
    slug: "asendia_usa",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "asendiausa",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "AsendiaUsa",
      requiresCredentials: true,
    },
    trackingUrl: (trackingCode) =>
      `https://a1.asendiausa.com/tracking/?trackingnumber=${trackingCode}`,
  },
  [SupportedCarrier.AUSTRALIA_POST]: {
    carrier: SupportedCarrier.AUSTRALIA_POST,
    displayName: "Australia Post",
    slug: "australia_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "australia-post",
    },
    // EasyPost tends to return "unknown" status.
    // However, I have seen it work for a small subset of Local Supply's Australia Post shipments
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "AustraliaPost",
    },
    trackingUrl: (trackingCode) =>
      `https://auspost.com.au/track/track.html?id=${trackingCode}`,
  },
  [SupportedCarrier.AXLEHIRE]: {
    carrier: SupportedCarrier.AXLEHIRE,
    displayName: "AxleHire",
    slug: "axlehire",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "axlehire",
    },
    trackingUrl: (trackingCode) =>
      `https://tracking.axlehire.com/${trackingCode}`,
  },
  [SupportedCarrier.BEN_BEN]: {
    carrier: SupportedCarrier.BEN_BEN,
    displayName: "BEN BEN",
    slug: "ben_ben",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "benben",
    },
  },
  [SupportedCarrier.BETTER_TRUCKS]: {
    carrier: SupportedCarrier.BETTER_TRUCKS,
    displayName: "Better Trucks",
    slug: "better_trucks",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "BetterTrucks",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "better-trucks",
    },
    trackingUrl: (trackingCode) =>
      `https://tracking.bettertrucks.com/Tracking?ShipmentId=${trackingCode}`,
  },
  [SupportedCarrier.BPOST]: {
    carrier: SupportedCarrier.BPOST,
    displayName: "BPost",
    slug: "bpost",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "belgium-post",
    },
    trackingUrl: () => "https://track.bpost.cloud/",
  },
  [SupportedCarrier.BRING]: {
    carrier: SupportedCarrier.BRING,
    displayName: "Bring",
    slug: "bring",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "bring",
    },
    trackingUrl: (trackingCode) =>
      `https://tracking.bring.com/tracking/${trackingCode}`,
  },
  [SupportedCarrier.CAINIAO]: {
    carrier: SupportedCarrier.CAINIAO,
    displayName: "Cainiao",
    slug: "cainiao",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "cainiao",
    },
    trackingUrl: (trackingCode) =>
      `https://global.cainiao.com/newDetail.htm?mailNoList=${trackingCode}`,
  },
  [SupportedCarrier.CANADA_POST]: {
    carrier: SupportedCarrier.CANADA_POST,
    displayName: "Canada Post",
    slug: "canada_post",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "CanadaPost",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "canada-post",
    },
    trackingUrl: (trackingCode) =>
      `https://www.canadapost.ca/trackweb/en#/details/${trackingCode}`,
  },
  [SupportedCarrier.CANPAR]: {
    carrier: SupportedCarrier.CANPAR,
    displayName: "Canpar",
    slug: "canpar",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Canpar",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "canpar",
    },
    trackingUrl: () => "https://www.canpar.com/en/tracking/track.htm",
  },
  [SupportedCarrier.CEVA_LOGISTICS]: {
    carrier: SupportedCarrier.CEVA_LOGISTICS,
    displayName: "CEVA Logistics",
    slug: "ceva_logistics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ceva-logistics",
    },
    trackingUrl: (trackingCode) =>
      `https://www.cevalogistics.com/en/ceva-trak?codes=${trackingCode}`,
  },
  [SupportedCarrier.CHIT_CHATS]: {
    carrier: SupportedCarrier.CHIT_CHATS,
    displayName: "Chit Chats",
    slug: "chit_chats",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "chitchats",
    },
    trackingUrl: (trackingCode) =>
      `https://chitchats.com/tracking/${trackingCode}`,
  },
  [SupportedCarrier.CIRRO_ECOMMERCE]: {
    carrier: SupportedCarrier.CIRRO_ECOMMERCE,
    displayName: "CIRRO E-Commerce",
    slug: "cirro_ecommerce",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "cirro",
    },
    trackingUrl: (trackingCode) =>
      `https://www.cirrotrack.com/parcelTracking?id=${trackingCode}`,
  },
  [SupportedCarrier.CIRRO_PARCEL]: {
    carrier: SupportedCarrier.CIRRO_PARCEL,
    displayName: "CIRRO Parcel",
    slug: "cirro_parcel",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "cirroparcel",
    },
    trackingUrl: (trackingCode) =>
      `https://www.cirrotrack.com/parcelTracking?id=${trackingCode}`,
  },
  [SupportedCarrier.CDL]: {
    carrier: SupportedCarrier.CDL,
    displayName: "CDL",
    slug: "cdl",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "ColumbusLastMile",
    },
    trackingUrl: (trackingCode) =>
      `https://ship.cdldelivers.com/Xcelerator/Tracking/Tracking?orderId=${trackingCode}`,
  },
  [SupportedCarrier.CHRONOPOST]: {
    carrier: SupportedCarrier.CHRONOPOST,
    displayName: "Chronopost",
    slug: "chronopost",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "chronopost",
    },
    trackingUrl: (trackingCode) =>
      `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${trackingCode}&op=&form_build_id=form-uQSOFWBpMMI83tEmBikhd6H5NBzWD5gLvzsqEzSNrWs&form_id=chrono_suivi_colis_block_form`,
  },
  [SupportedCarrier.CHINA_POST]: {
    carrier: SupportedCarrier.CHINA_POST,
    displayName: "China Post",
    slug: "china_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "china-post",
    },
    trackingUrl: (trackingCode) =>
      `https://parcelsapp.com/en/tracking/${trackingCode}`,
  },
  [SupportedCarrier.COLIS_PRIVE]: {
    carrier: SupportedCarrier.COLIS_PRIVE,
    displayName: "Colis Privé",
    slug: "colis_prive",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "colis-prive",
    },
    trackingUrl: (trackingCode) =>
      `https://www.colisprive.com/?id=${trackingCode}`,
  },
  [SupportedCarrier.COURIER_EXPRESS]: {
    carrier: SupportedCarrier.COURIER_EXPRESS,
    displayName: "Courier Express",
    slug: "courier_express",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "CourierExpress",
    },
  },
  [SupportedCarrier.COURIERSPLEASE]: {
    carrier: SupportedCarrier.COURIERSPLEASE,
    displayName: "CouriersPlease",
    slug: "couriersplease",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "CouriersPlease",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "couriers-please",
    },
    trackingUrl: (trackingCode) =>
      `https://www.couriersplease.com.au/track?l=${trackingCode}`,
  },
  [SupportedCarrier.CTT_EXPRESS]: {
    carrier: SupportedCarrier.CTT_EXPRESS,
    displayName: "CTT Express",
    slug: "ctt_express",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ctt-express",
    },
    trackingUrl: (trackingCode) =>
      `https://www.cttexpress.com/localizador-de-envios/?sc=${trackingCode}`,
  },
  [SupportedCarrier.DAI_POST]: {
    carrier: SupportedCarrier.DAI_POST,
    displayName: "DAI Post",
    slug: "dai_post",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DaiPost",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "daipost",
    },
    trackingUrl: () => "https://www.daipost.com/",
  },
  [SupportedCarrier.DEUTSCHE_POST]: {
    carrier: SupportedCarrier.DEUTSCHE_POST,
    displayName: "Deutsche Post",
    slug: "deutsche_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "deutsche-post",
    },
    trackingUrl: () => "https://www.deutschepost.de/sendung/simpleQuery.html",
  },
  [SupportedCarrier.DEUTSCHE_POST_UK]: {
    carrier: SupportedCarrier.DEUTSCHE_POST_UK,
    displayName: "Deutsche Post UK",
    slug: "deutsche_post_uk",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DeutschePostUK",
    },
  },
  // dhl_ecommerce_us: use dhl_ecommerce instead (same DHL eCommerce service)
  [SupportedCarrier.DHL_ECOMMERCE]: {
    carrier: SupportedCarrier.DHL_ECOMMERCE,
    displayName: "DHL eCommerce",
    slug: "dhl_ecommerce",
    // EasyPost (credentialed) is cheaper and tracks DHL fully; Track123 stays
    // secondary so a failed EasyPost registration falls back.
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DhlEcs",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dhlglobalmail",
    },
    trackingUrl: (trackingCode) =>
      `https://webtrack.dhlglobalmail.com/?trackingnumber=${trackingCode}`,
  },
  [SupportedCarrier.DHL_ECOMMERCE_ASIA]: {
    carrier: SupportedCarrier.DHL_ECOMMERCE_ASIA,
    displayName: "DHL eCommerce Asia",
    slug: "dhl_ecommerce_asia",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dhl-ecommerce-asia",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dhl.com/us-en/home/tracking/tracking-ecommerce.html?locale=true&tracking-id=${trackingCode}`,
  },
  [SupportedCarrier.DHL_EXPRESS]: {
    carrier: SupportedCarrier.DHL_EXPRESS,
    displayName: "DHL Express",
    slug: "dhl_express",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "dhlexpress",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dhl.com/en/express/tracking.html?AWB=${trackingCode}`,
  },
  [SupportedCarrier.DHL_PAKET]: {
    carrier: SupportedCarrier.DHL_PAKET,
    displayName: "DHL Paket",
    slug: "dhl_paket",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DhlPaket",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dhl-germany",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dhl.com/de-en/home/tracking/tracking-parcel.html?submit=1&tracking-id=${trackingCode}`,
  },
  [SupportedCarrier.DHL_PARCEL]: {
    carrier: SupportedCarrier.DHL_PARCEL,
    displayName: "DHL Parcel",
    slug: "dhl_parcel",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DhlParcel",
      requiresCredentials: true,
    },
    trackingUrl: (trackingCode) =>
      `https://www.dhl.com/us-en/home/tracking/tracking-parcel.html?locale=true&tracking-id=${trackingCode}`,
  },
  [SupportedCarrier.DHL_PARCEL_NL]: {
    carrier: SupportedCarrier.DHL_PARCEL_NL,
    displayName: "DHL Parcel NL",
    slug: "dhl_parcel_nl",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dhlparcel",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dhlparcel.nl/?id=${trackingCode}`,
  },
  [SupportedCarrier.DPD_UK]: {
    carrier: SupportedCarrier.DPD_UK,
    displayName: "DPD UK",
    slug: "dpd_uk",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DpdUk",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dpd-uk",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dpd.co.uk/apps/tracking/?reference=${trackingCode}#results`,
  },
  [SupportedCarrier.DOORDASH]: {
    carrier: SupportedCarrier.DOORDASH,
    displayName: "DoorDash",
    slug: "doordash",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DoorDash",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "doordash",
    },
  },
  [SupportedCarrier.DPD]: {
    carrier: SupportedCarrier.DPD,
    displayName: "DPD",
    slug: "dpd",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Dpd",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dpd",
    },
  },
  [SupportedCarrier.DPD_LOCAL]: {
    carrier: SupportedCarrier.DPD_LOCAL,
    displayName: "DPD Local",
    slug: "dpd_local",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Dpd",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dpdlocal.co.uk/apps/tracking/?reference=${trackingCode}`,
  },
  [SupportedCarrier.DPD_NL]: {
    carrier: SupportedCarrier.DPD_NL,
    displayName: "DPD NL",
    slug: "dpd_nl",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "DpdNl",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "dpd-nl",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dpdgroup.com/nl/mydpd/my-parcels/incoming?parcelNumber=${trackingCode}`,
  },
  // rr_donnelley: RR Donnelley rebranded to ePost Global; EasyPost still uses RRDonnelley as the carrier code
  [SupportedCarrier.EPOST_GLOBAL]: {
    carrier: SupportedCarrier.EPOST_GLOBAL,
    displayName: "ePost Global",
    slug: "epost_global",
    // Easypost supports RRDonnelley,
    // However, in manual testing, Easypost outputs bad data. Not failure, just wrong info.
    // Do not enable Easypost without further testing.
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "epostglobal",
    },
    // Unneccessary but mildly interesting info:
    // epgtrack.com is a .NET MVC site with no URL parameters.
    // Its JS code is unobfuscated but does not reveal any query parameters for deep linking.
    // It is potentially the worst tracking site ever made.
    // To be fair, they only do $12M in revenue so what did I expect.
    // Do not judge MVC because of this, it's the only good part of C#
    // See also https://joshmoody.org/blog/hidden-pitfalls-of-blazor/#experimenting-with-mvc--htmx
    trackingUrl: () => "https://epgtrack.com/",
  },
  [SupportedCarrier.ESHIPPER]: {
    carrier: SupportedCarrier.ESHIPPER,
    displayName: "eShipper",
    slug: "eshipper",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "eshipper",
    },
    trackingUrl: (trackingCode) =>
      `https://ww2.eshipper.com/track-shipment/r?trackingNumber=${trackingCode}`,
  },
  [SupportedCarrier.ESTAFETA]: {
    carrier: SupportedCarrier.ESTAFETA,
    displayName: "Estafeta",
    slug: "estafeta",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Estafeta",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "estafeta",
    },
    trackingUrl: () => "https://www.estafeta.com/Herramientas/Rastreo",
  },
  [SupportedCarrier.ESTES]: {
    carrier: SupportedCarrier.ESTES,
    displayName: "Estes",
    slug: "estes",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "estesexpress",
    },
    trackingUrl: () =>
      "https://www.estes-express.com/myestes/shipment-tracking/?query=&type=PRO",
  },
  [SupportedCarrier.EVRI]: {
    carrier: SupportedCarrier.EVRI,
    displayName: "Evri",
    slug: "evri",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Hermes",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "evri",
    },
    trackingUrl: (trackingCode) =>
      `https://www.evri.com/track/parcel/${trackingCode}/details`,
  },
  [SupportedCarrier.FEDEX]: {
    carrier: SupportedCarrier.FEDEX,
    displayName: "FedEx",
    slug: "fedex",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "FedEx",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "fedex",
    },
    trackingUrl: (trackingCode) =>
      `https://www.fedex.com/fedextrack/?trknbr=${trackingCode}`,
  },
  [SupportedCarrier.FEDEX_CROSS_BORDER]: {
    carrier: SupportedCarrier.FEDEX_CROSS_BORDER,
    displayName: "FedEx Cross Border",
    slug: "fedex_cross_border",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "FedexCrossBorder",
    },
    trackingUrl: (trackingCode) =>
      `https://fcbtracking.fedex.com/?MyFICNumber=${trackingCode}`,
  },
  [SupportedCarrier.FEDEX_MAILVIEW]: {
    carrier: SupportedCarrier.FEDEX_MAILVIEW,
    displayName: "FedEx MailView",
    slug: "fedex_mailview",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Fedex",
    },
    trackingUrl: () =>
      "https://mailviewrecipient.fedex.com/recip_package_summary.aspx",
  },
  [SupportedCarrier.FEDEX_SAMEDAY_CITY]: {
    carrier: SupportedCarrier.FEDEX_SAMEDAY_CITY,
    displayName: "FedEx SameDay City",
    slug: "fedex_sameday_city",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Fedex",
    },
    trackingUrl: (trackingCode) =>
      `https://www.fedex.com/fedextrack/?trknbr=${trackingCode}`,
  },
  [SupportedCarrier.FEDEX_SMART_POST]: {
    carrier: SupportedCarrier.FEDEX_SMART_POST,
    displayName: "FedEx SmartPost",
    slug: "fedex_smart_post",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "FedexSmartpost",
    },
    trackingUrl: (trackingCode) =>
      `https://www.fedex.com/fedextrack/?trknbr=${trackingCode}`,
  },
  [SupportedCarrier.FIRSTMILE]: {
    carrier: SupportedCarrier.FIRSTMILE,
    displayName: "FirstMile",
    slug: "firstmile",
    primaryProvider: {
      provider: TrackingProvider.FIRST_MILE,
      carrierCode: "FirstMile",
    },
    trackingUrl: (trackingCode) =>
      `https://track.firstmile.com/detail.php?n=${trackingCode}`,
  },
  [SupportedCarrier.FLEET_OPTICS]: {
    carrier: SupportedCarrier.FLEET_OPTICS,
    displayName: "Fleet Optics",
    slug: "fleet_optics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "fleetoptics",
    },
    trackingUrl: (trackingCode) =>
      `https://track.fleetopticsinc.com/?tracking_number=${trackingCode}`,
  },
  // gso: use gls instead (same company, GLS acquired GSO)
  [SupportedCarrier.GLS]: {
    carrier: SupportedCarrier.GLS,
    displayName: "GLS",
    slug: "gls",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "gls-us",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "GSO",
    },
    trackingUrl: (trackingCode) =>
      `https://www.gls-us.com/track-and-trace?TrackingNumbers=${trackingCode}`,
  },
  [SupportedCarrier.GOBOLT]: {
    carrier: SupportedCarrier.GOBOLT,
    displayName: "GoBolt",
    slug: "gobolt",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "gobolt",
    },
    trackingUrl: (trackingCode) =>
      `https://track.gobolt.com/tracking/${trackingCode}`,
  },
  [SupportedCarrier.GOFO_EXPRESS]: {
    carrier: SupportedCarrier.GOFO_EXPRESS,
    displayName: "GOFO Express",
    slug: "gofo_express",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "gofo-express",
    },
    trackingUrl: (trackingCode) =>
      `https://www.gofo.com/us/track?searchID=${trackingCode}`,
  },
  [SupportedCarrier.GOFO_NETHERLANDS]: {
    carrier: SupportedCarrier.GOFO_NETHERLANDS,
    displayName: "GOFO Netherlands",
    slug: "gofo_netherlands",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "gofo-nl",
    },
    trackingUrl: () => "https://www.gofo.com/nl/en/tracking-results/",
  },
  [SupportedCarrier.HAILIFY]: {
    carrier: SupportedCarrier.HAILIFY,
    displayName: "Hailify",
    slug: "hailify",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Hailify",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "hailify",
    },
    trackingUrl: () => "https://searchorder.drivegomo.com/tracking/",
  },
  [SupportedCarrier.HERMES_DE]: {
    carrier: SupportedCarrier.HERMES_DE,
    displayName: "Hermes DE",
    slug: "hermes_de",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "hermes-de",
    },
    trackingUrl: (trackingCode) =>
      `https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation#${trackingCode}`,
  },
  [SupportedCarrier.HONG_KONG_POST]: {
    carrier: SupportedCarrier.HONG_KONG_POST,
    displayName: "Hong Kong Post",
    slug: "hong_kong_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "hong-kong-post",
    },
    trackingUrl: () =>
      "https://webapp.hongkongpost.hk/en/mail_tracking2/index.html",
  },
  [SupportedCarrier.ICS]: {
    carrier: SupportedCarrier.ICS,
    displayName: "ICS",
    slug: "ics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ics-courier",
    },
    trackingUrl: (trackingCode) =>
      `https://www.icscourier.ca/online-services/parcel-tracking.aspx?trackNums=${trackingCode}`,
  },
  [SupportedCarrier.IMILE]: {
    carrier: SupportedCarrier.IMILE,
    displayName: "iMile",
    slug: "imile",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "imile",
    },
    trackingUrl: (trackingCode) => `https://www.imile.com/?id=${trackingCode}`,
  },
  [SupportedCarrier.INTELCOM]: {
    carrier: SupportedCarrier.INTELCOM,
    displayName: "Intelcom",
    slug: "intelcom",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "intelcom",
    },
    trackingUrl: (trackingCode) =>
      `https://intelcom.ca/en/track-your-package/?tracking-id=${trackingCode}`,
  },
  [SupportedCarrier.INTERLINK_EXPRESS]: {
    carrier: SupportedCarrier.INTERLINK_EXPRESS,
    displayName: "Interlink Express",
    slug: "interlink_express",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "InterlinkExpress",
    },
    trackingUrl: (trackingCode) =>
      `https://www.dpdlocal.co.uk/apps/tracking/?reference=${trackingCode}`,
  },
  [SupportedCarrier.JAPAN_POST]: {
    carrier: SupportedCarrier.JAPAN_POST,
    displayName: "JP Post",
    slug: "japan_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "japan-post",
    },
    trackingUrl: (trackingCode) =>
      `https://trackings.post.japanpost.jp/services/srv/search/direct?locale=en&reqCodeNo1=${trackingCode}`,
  },
  [SupportedCarrier.JS_EXPRESS]: {
    carrier: SupportedCarrier.JS_EXPRESS,
    displayName: "JS Express",
    slug: "js_express",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "js-exp",
    },
  },
  [SupportedCarrier.JITSU]: {
    carrier: SupportedCarrier.JITSU,
    displayName: "Jitsu",
    slug: "jitsu",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "jitsu",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Jitsu",
      requiresCredentials: true,
    },
    trackingUrl: (trackingCode) =>
      `https://tracking.gojitsu.com/${trackingCode}`,
  },
  [SupportedCarrier.KART2DOOR]: {
    carrier: SupportedCarrier.KART2DOOR,
    displayName: "Kart2Door",
    slug: "kart2door",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "kart2door",
    },
    trackingUrl: (trackingCode) =>
      `https://www.kart2door.com/EcomTracking?axb=${trackingCode}`,
  },
  [SupportedCarrier.LANDMARK_GLOBAL]: {
    carrier: SupportedCarrier.LANDMARK_GLOBAL,
    displayName: "Landmark Global",
    slug: "landmark_global",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "landmarkglobal",
    },
    trackingUrl: (trackingCode) =>
      `https://track.landmarkglobal.com/?search=${trackingCode}`,
  },
  [SupportedCarrier.LA_POSTE]: {
    carrier: SupportedCarrier.LA_POSTE,
    displayName: "La Poste",
    slug: "la_poste",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "laposte",
    },
    trackingUrl: (trackingCode) =>
      `https://www.laposte.fr/outils/suivre-vos-envois?code=${trackingCode}`,
  },
  [SupportedCarrier.LASERSHIP]: {
    carrier: SupportedCarrier.LASERSHIP,
    displayName: "OnTrac",
    slug: "lasership",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "lasership",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "LaserShip",
    },
    trackingUrl: (trackingCode) =>
      `https://t.lasership.com/Track/${trackingCode}`,
  },
  [SupportedCarrier.LOOMIS_EXPRESS]: {
    carrier: SupportedCarrier.LOOMIS_EXPRESS,
    displayName: "Loomis Express",
    slug: "loomis_express",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "LoomisExpress",
    },
    trackingUrl: (trackingCode) =>
      `https://www.loomisexpress.com/loomship/en/Track/TrackResults?t=WAYBILL&s=${trackingCode}`,
  },
  [SupportedCarrier.LSO]: {
    carrier: SupportedCarrier.LSO,
    displayName: "LSO",
    slug: "lso",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Lso",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "lso",
    },
    trackingUrl: (trackingCode) =>
      `https://www2.lso.com/access/trackingresult.aspx?airbillnos=${trackingCode}`,
  },
  [SupportedCarrier.LOTTE_GLOBAL_LOGISTICS]: {
    carrier: SupportedCarrier.LOTTE_GLOBAL_LOGISTICS,
    displayName: "Lotte Global Logistics",
    slug: "lotte_global_logistics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "lotte-global-logistics",
    },
    trackingUrl: (trackingCode) =>
      `https://www.lotteglogis.com/english/reservation/track/?id=${trackingCode}`,
  },
  [SupportedCarrier.MAINFREIGHT]: {
    carrier: SupportedCarrier.MAINFREIGHT,
    displayName: "Mainfreight",
    slug: "mainfreight",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "mainfreight",
    },
    trackingUrl: (trackingCode) =>
      `https://t.17track.net/en#nums=${trackingCode}`,
  },
  [SupportedCarrier.METROPOLITAN]: {
    carrier: SupportedCarrier.METROPOLITAN,
    displayName: "Metropolitan",
    slug: "metropolitan",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "metropolitan",
    },
    trackingUrl: (trackingCode) =>
      `https://www.gomwd.com/track-a-shipment/${trackingCode}`,
  },
  [SupportedCarrier.NEWGISTICS]: {
    carrier: SupportedCarrier.NEWGISTICS,
    displayName: "Newgistics",
    slug: "newgistics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "newgistics",
    },
    trackingUrl: (trackingCode) => `https://tracking.pb.com/${trackingCode}`,
  },
  [SupportedCarrier.NINJAVAN]: {
    carrier: SupportedCarrier.NINJAVAN,
    displayName: "Ninja Van",
    slug: "ninjavan",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ninjavan_int",
    },
    trackingUrl: (trackingCode) =>
      `https://www.ninjavan.co/en-sg/tracking/?id=${trackingCode}`,
  },
  [SupportedCarrier.NEXTSMARTSHIP]: {
    carrier: SupportedCarrier.NEXTSMARTSHIP,
    displayName: "NextSmartShip",
    slug: "nextsmartship",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "nextsmartship",
    },
    trackingUrl: (trackingCode) =>
      `https://fulfillship.nextsmartship.com/track?s=${trackingCode}`,
  },
  [SupportedCarrier.NORWAY_POST]: {
    carrier: SupportedCarrier.NORWAY_POST,
    displayName: "Norway Post",
    slug: "norway_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "norway-post",
    },
    trackingUrl: (trackingCode) =>
      `https://sporing.posten.no/sporing/${trackingCode}`,
  },
  [SupportedCarrier.NZ_POST]: {
    carrier: SupportedCarrier.NZ_POST,
    displayName: "NZ Post (New Zealand Post)",
    slug: "nz_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "new-zealand-post",
    },
    trackingUrl: (trackingCode) =>
      `https://www.nzpost.co.nz/tools/tracking?trackid=${trackingCode}`,
  },
  // omniparcel: duplicate of omni_parcel (same carrier)
  [SupportedCarrier.OMNI_PARCEL]: {
    carrier: SupportedCarrier.OMNI_PARCEL,
    displayName: "OmniParcel",
    slug: "omni_parcel",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "OmniParcel",
    },
    trackingUrl: (trackingCode) =>
      `https://track.omniparcel.com/?id=${trackingCode}`,
  },
  [SupportedCarrier.OMNIVA]: {
    carrier: SupportedCarrier.OMNIVA,
    displayName: "Omniva",
    slug: "omniva",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "omniva",
    },
    trackingUrl: (trackingCode) =>
      `https://minu.omniva.ee/track/${trackingCode}`,
  },
  [SupportedCarrier.ON_TRAC]: {
    carrier: SupportedCarrier.ON_TRAC,
    displayName: "OnTrac",
    slug: "on_trac",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ontrac",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "OnTrac",
    },
    trackingUrl: (trackingCode) =>
      `https://www.ontrac.com/tracking/?number=${trackingCode}`,
  },
  [SupportedCarrier.OPTIMA]: {
    carrier: SupportedCarrier.OPTIMA,
    displayName: "Optima",
    slug: "optima",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Optima",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "optima",
    },
    trackingUrl: () =>
      "https://www.optima.e-courier.com/optima/home/Wizard_tracking.asp?UserGUID=",
  },
  [SupportedCarrier.OSM_WORLDWIDE]: {
    carrier: SupportedCarrier.OSM_WORLDWIDE,
    displayName: "OSM Worldwide",
    slug: "osm_worldwide",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "osmworldwide",
    },
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "OsmWorldwideV2",
      requiresCredentials: true,
    },
    trackingUrl: (trackingCode) =>
      `https://www.osmworldwide.com/tracking/?trackingNumbers=${trackingCode}`,
  },
  [SupportedCarrier.PARCELFORCE]: {
    carrier: SupportedCarrier.PARCELFORCE,
    displayName: "Parcelforce",
    slug: "parcelforce",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "parcelforce",
    },
    trackingUrl: () => "https://www.parcelforce.com/track-trace",
  },
  [SupportedCarrier.PARCLL]: {
    carrier: SupportedCarrier.PARCLL,
    displayName: "PARCLL",
    slug: "parcll",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Parcll",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "parcll",
    },
    trackingUrl: (trackingCode) =>
      `https://www.parclltrack.com/parcelTracking?id=${trackingCode}`,
  },
  [SupportedCarrier.PASSPORT]: {
    carrier: SupportedCarrier.PASSPORT,
    displayName: "Passport",
    slug: "passport",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "PassportGlobal",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "passport",
    },
    trackingUrl: (trackingCode) =>
      `https://track.passportshipping.com/${trackingCode}`,
  },
  [SupportedCarrier.PITNEY_BOWES]: {
    carrier: SupportedCarrier.PITNEY_BOWES,
    displayName: "Passport",
    slug: "pitney_bowes",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "pitneybowes",
    },
    trackingUrl: (trackingCode) =>
      `https://trackpb.shipment.co/track?number=${trackingCode}`,
  },
  [SupportedCarrier.POLAND_POST]: {
    carrier: SupportedCarrier.POLAND_POST,
    displayName: "Poland Post",
    slug: "poland_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "poczta-polska",
    },
    trackingUrl: () => "https://www.poczta-polska.pl/sledzenie-przesylek/",
  },
  // Post NL is intentionally not supported because it requires also sending
  // the postalCode in the registration payload, which requires some core
  // changes we don't want to make right now.
  // [SupportedCarrier.POSTNL]: {
  //   carrier: SupportedCarrier.POSTNL,
  //   displayName: "PostNL",
  //   slug: "postnl",
  //   primaryProvider: {
  //     provider: TrackingProvider.TRACK123,
  //     carrierCode: "postnl",
  //   },
  //   trackingUrl: () => "https://postnl.post/tracktrace",
  // },
  [SupportedCarrier.POSTNL_INTERNATIONAL]: {
    carrier: SupportedCarrier.POSTNL_INTERNATIONAL,
    displayName: "PostNL International",
    slug: "postnl_international",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "postnl-parcels",
    },
    trackingUrl: () => "https://postnl.post/tracktrace/",
  },
  [SupportedCarrier.QUINCE_LOGISTICS]: {
    carrier: SupportedCarrier.QUINCE_LOGISTICS,
    displayName: "Quince Logistics (QLS)",
    slug: "quince_logistics",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "qls",
    },
    trackingUrl: (trackingCode) =>
      `https://qls.quince.com/qls/track/${trackingCode}`,
  },
  [SupportedCarrier.PUROLATOR]: {
    carrier: SupportedCarrier.PUROLATOR,
    displayName: "Purolator",
    slug: "purolator",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Purolator",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "purolator",
    },
    trackingUrl: (trackingCode) =>
      `https://www.purolator.com/en/shipping/tracker?pin=${trackingCode}`,
  },
  [SupportedCarrier.RELAY]: {
    carrier: SupportedCarrier.RELAY,
    displayName: "Relay",
    slug: "relay",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "relay",
    },
    trackingUrl: () => "https://www.relaytech.co/track-order",
  },
  [SupportedCarrier.R_PLUS_L_CARRIERS]: {
    carrier: SupportedCarrier.R_PLUS_L_CARRIERS,
    displayName: "R+L Carriers",
    slug: "r_plus_l_carriers",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "rl-carriers",
    },
    trackingUrl: (trackingCode) =>
      `https://www.rlcarriers.com/freight/shipping/shipment-tracing?pro=${trackingCode}&docType=PRO`,
  },
  [SupportedCarrier.ROYAL_MAIL]: {
    carrier: SupportedCarrier.ROYAL_MAIL,
    displayName: "Royal Mail",
    slug: "royal_mail",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "royal-mail",
    },
    // Without the merchant's own account EasyPost accepts the code and never returns a scan.
    secondaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "royalmail",
      requiresCredentials: true,
    },
    trackingUrl: (trackingCode) =>
      `https://www.royalmail.com/portal/rm/track?trackNumber=${trackingCode}`,
  },
  [SupportedCarrier.ROYAL_MAIL_V3]: {
    carrier: SupportedCarrier.ROYAL_MAIL_V3,
    displayName: "Royal Mail V3",
    slug: "royal_mail_v3",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "RoyalMailV3",
    },
    trackingUrl: (trackingCode) =>
      `https://www.royalmail.com/portal/rm/track?trackNumber=${trackingCode}`,
  },
  [SupportedCarrier.SAGAWA]: {
    carrier: SupportedCarrier.SAGAWA,
    displayName: "Sagawa",
    slug: "sagawa",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sagawa",
    },
    trackingUrl: () =>
      "https://k2k.sagawa-exp.co.jp/p/sagawa/web/okurijoinput.jsp",
  },
  [SupportedCarrier.SAIA]: {
    carrier: SupportedCarrier.SAIA,
    displayName: "SAIA",
    slug: "saia",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "saia-freight",
    },
    trackingUrl: (trackingCode) =>
      `https://www.saia.com/track/details;pro=${trackingCode}`,
  },
  [SupportedCarrier.SDH]: {
    carrier: SupportedCarrier.SDH,
    displayName: "SDH",
    slug: "sdh",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sdh",
    },
  },
  [SupportedCarrier.SEKO]: {
    carrier: SupportedCarrier.SEKO,
    displayName: "SEKO Logistics",
    slug: "seko",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "seko",
    },
    trackingUrl: (trackingCode) =>
      `https://www.sekologistics.com/us/track/?trackingNumbers=${trackingCode}`,
  },
  [SupportedCarrier.SENDLE]: {
    carrier: SupportedCarrier.SENDLE,
    displayName: "Sendle",
    slug: "sendle",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sendle",
    },
    trackingUrl: (trackingCode) =>
      `https://track.sendle.com/tracking?ref=${trackingCode}`,
  },
  [SupportedCarrier.SF_EXPRESS]: {
    carrier: SupportedCarrier.SF_EXPRESS,
    displayName: "SF Express",
    slug: "sf_express",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "SfExpress",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sfb2c",
    },
    trackingUrl: () =>
      "https://www.sf-international.com/us/en/dynamic_function/waybill/",
  },
  [SupportedCarrier.SHIP_BOB]: {
    carrier: SupportedCarrier.SHIP_BOB,
    displayName: "ShipBob",
    slug: "ship_bob",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "shipbob",
    },
    trackingUrl: (trackingCode) => `https://track.shipbob.com/${trackingCode}`,
  },
  [SupportedCarrier.SINGAPORE_POST]: {
    carrier: SupportedCarrier.SINGAPORE_POST,
    displayName: "Singapore Post",
    slug: "singapore_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "singapore-post",
    },
    trackingUrl: (trackingCode) =>
      `https://www.singpost.com/track-items?trackingid=${trackingCode}`,
  },
  [SupportedCarrier.SMARTKARGO]: {
    carrier: SupportedCarrier.SMARTKARGO,
    displayName: "SmartKargo",
    slug: "smartkargo",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "SmartKargo",
    },
    trackingUrl: () => "https://masair.smartkargo.com/TrackFrame.aspx",
  },
  [SupportedCarrier.SONIC]: {
    carrier: SupportedCarrier.SONIC,
    displayName: "Sonic",
    slug: "sonic",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Sonic",
    },
    trackingUrl: () => "https://www.sonictl.com/",
  },
  [SupportedCarrier.SOUTHEASTERN_FREIGHT_LINES]: {
    carrier: SupportedCarrier.SOUTHEASTERN_FREIGHT_LINES,
    displayName: "Southeastern Freight Lines",
    slug: "southeastern_freight_lines",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "southeastern-freight-lines",
    },
    trackingUrl: (trackingCode) =>
      `https://www.sefl.com/webconnect/tracing?Type=PN&RefNum1=${trackingCode}`,
  },
  [SupportedCarrier.SPEEDEE]: {
    carrier: SupportedCarrier.SPEEDEE,
    displayName: "Spee-Dee",
    slug: "speedee",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Speedee",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "speedee",
    },
    trackingUrl: (trackingCode) =>
      `https://speedeedelivery.com/track-a-shipment/?v=detail&barcode=${trackingCode}`,
  },
  [SupportedCarrier.SPEEDX]: {
    carrier: SupportedCarrier.SPEEDX,
    displayName: "SpeedX",
    slug: "speedx",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "SpeedX",
      requiresCredentials: true,
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "speedx",
    },
    trackingUrl: (trackingCode) => `https://tracking.speedx.io/${trackingCode}`,
  },
  [SupportedCarrier.STARTRACK]: {
    carrier: SupportedCarrier.STARTRACK,
    displayName: "StarTrack",
    slug: "startrack",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "star-track",
    },
    trackingUrl: () => "https://startrack.com.au/track/search",
  },
  [SupportedCarrier.STONE3PL]: {
    carrier: SupportedCarrier.STONE3PL,
    displayName: "Stone3PL",
    slug: "stone3pl",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "stone3pl",
    },
    trackingUrl: (trackingCode) =>
      `https://stone3pl.com/?route=services%2Ftrack&nums=${trackingCode}`,
  },
  [SupportedCarrier.SWAY]: {
    carrier: SupportedCarrier.SWAY,
    displayName: "Sway",
    slug: "sway",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sway",
    },
    trackingUrl: (trackingCode) => `https://track.shipsway.com/${trackingCode}`,
  },
  [SupportedCarrier.SUNYOU]: {
    carrier: SupportedCarrier.SUNYOU,
    displayName: "SunYou",
    slug: "sunyou",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "sunyou",
    },
    trackingUrl: (trackingCode) =>
      `https://www.sypost.net/search?orderNo=${trackingCode}`,
  },
  [SupportedCarrier.SWISS_POST]: {
    carrier: SupportedCarrier.SWISS_POST,
    displayName: "Swiss Post",
    slug: "swiss_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "swiss-post",
    },
    trackingUrl: (trackingCode) =>
      `https://service.post.ch/ekp-web/ui/entry/search/${trackingCode}`,
  },
  [SupportedCarrier.SWIFTX]: {
    carrier: SupportedCarrier.SWIFTX,
    displayName: "SwiftX",
    slug: "swiftx",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "swiftx",
    },
  },
  [SupportedCarrier.SWYFT]: {
    carrier: SupportedCarrier.SWYFT,
    displayName: "Swyft",
    slug: "swyft",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Swyft",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "swyft",
    },
    trackingUrl: () => "https://track.useswyft.com/",
  },
  [SupportedCarrier.TELE_POST]: {
    carrier: SupportedCarrier.TELE_POST,
    displayName: "Tele Post",
    slug: "tele_post",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "tele-post",
    },
    trackingUrl: (trackingCode) =>
      `https://www.tele-post.dk/spoer-din-pakke/?id=${trackingCode}`,
  },
  [SupportedCarrier.TFORCE]: {
    carrier: SupportedCarrier.TFORCE,
    displayName: "TForce Logistics",
    slug: "tforce",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "TforceConcise",
    },
    trackingUrl: (trackingCode) =>
      `https://direct.tfesg.com/finalmiletrack/Track?trackingNumber=${trackingCode}`,
  },
  [SupportedCarrier.TOLL]: {
    carrier: SupportedCarrier.TOLL,
    displayName: "Toll",
    slug: "toll",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "toll",
    },
    trackingUrl: () => "https://www.mytoll.com/",
  },
  [SupportedCarrier.TUSK]: {
    carrier: SupportedCarrier.TUSK,
    displayName: "Tusk Logistics",
    slug: "tusk",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "tusklogistics",
    },
    trackingUrl: (trackingCode) =>
      `https://shipmenttracking.tusklogistics.com/?trackingNumber=${trackingCode}`,
  },
  [SupportedCarrier.UDS]: {
    carrier: SupportedCarrier.UDS,
    displayName: "UDS",
    slug: "uds",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "Uds",
    },
    trackingUrl: (trackingCode) =>
      `https://www.uniteddeliveryservice.com/track/barcode/${trackingCode}`,
  },
  [SupportedCarrier.UNIUNI]: {
    carrier: SupportedCarrier.UNIUNI,
    displayName: "UniUni",
    slug: "uniuni",
    distrustDeliveryEstimate: true, // UniUni doesn't provide them, and Track123 hallucinates EDD to be today's date
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "uniuni",
    },
    trackingUrl: (trackingCode) =>
      `https://www.uniuni.com/tracking/#tracking-detail?no=${trackingCode}`,
  },
  [SupportedCarrier.UPS]: {
    carrier: SupportedCarrier.UPS,
    displayName: "UPS",
    slug: "ups",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "UPS",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ups",
    },
    trackingUrl: (trackingCode) =>
      `https://www.ups.com/track?tracknum=${trackingCode}`,
  },
  [SupportedCarrier.UPS_MAIL_INNOVATIONS]: {
    carrier: SupportedCarrier.UPS_MAIL_INNOVATIONS,
    displayName: "UPS Mail Innovations",
    slug: "ups_mail_innovations",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "UPSMailInnovations",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "ups-mail-innovations",
    },
    trackingUrl: (trackingCode) =>
      `https://www.ups.com/track?tracknum=${trackingCode}`,
  },
  [SupportedCarrier.USPS]: {
    carrier: SupportedCarrier.USPS,
    displayName: "USPS",
    slug: "usps",
    primaryProvider: {
      provider: TrackingProvider.EASYPOST,
      carrierCode: "USPS",
    },
    secondaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "usps",
    },
    trackingUrl: (trackingCode) =>
      `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${trackingCode}`,
  },
  [SupportedCarrier.VEHO]: {
    carrier: SupportedCarrier.VEHO,
    displayName: "Veho",
    slug: "veho",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "veho",
    },
    // easypost does the fake provider success thing without carrier credentials
    trackingUrl: (trackingCode) =>
      `https://track.shipveho.com/#/barcode/${trackingCode}`,
  },
  [SupportedCarrier.WANB_EXPRESS]: {
    carrier: SupportedCarrier.WANB_EXPRESS,
    displayName: "Wanb Express",
    slug: "wanb_express",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "wanbexpress",
    },
    trackingUrl: (trackingCode) =>
      `https://tracking.wanbexpress.com/?trackingNumbers=${trackingCode}`,
  },
  [SupportedCarrier.WIZMO]: {
    carrier: SupportedCarrier.WIZMO,
    displayName: "Wizmo",
    slug: "wizmo",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "shipwizmo",
    },
    trackingUrl: (trackingCode) =>
      `https://shipwizmo.com/tracking/${trackingCode}`,
  },
  [SupportedCarrier.WHISTL]: {
    carrier: SupportedCarrier.WHISTL,
    displayName: "Whistl",
    slug: "whistl",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "whistl",
    },
    trackingUrl: (trackingCode) =>
      `https://trackmyitem.whistl.co.uk/tracking/${trackingCode}`,
  },
  [SupportedCarrier.XPO]: {
    carrier: SupportedCarrier.XPO,
    displayName: "XPO",
    slug: "xpo",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "xpologistics",
    },
    trackingUrl: (trackingCode) =>
      `https://ext-web.ltl-xpo.com/public-app/shipments?referenceNumber=${trackingCode}`,
  },
  [SupportedCarrier.YANWEN]: {
    carrier: SupportedCarrier.YANWEN,
    displayName: "Yanwen",
    slug: "yanwen",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "yanwen",
    },
    trackingUrl: () => "https://track.yw56.com.cn/en/index",
  },
  [SupportedCarrier.YODEL]: {
    carrier: SupportedCarrier.YODEL,
    displayName: "Yodel",
    slug: "yodel",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "yodel",
    },
    trackingUrl: () => "https://www.yodel.net.cn/track",
  },
  [SupportedCarrier.YUN_EXPRESS]: {
    carrier: SupportedCarrier.YUN_EXPRESS,
    displayName: "YunExpress",
    slug: "yun_express",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "yunexpress",
    },
    trackingUrl: (trackingCode) =>
      `https://m.yuntrack.com/parcelTracking?id=${trackingCode}`,
  },
  // city_mail: split into city_mail_se and city_mail_pk for Track123 support
  [SupportedCarrier.CITY_MAIL_SE]: {
    carrier: SupportedCarrier.CITY_MAIL_SE,
    displayName: "CityMail SE",
    slug: "city_mail_se",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "citymail-se",
    },
  },
  [SupportedCarrier.CITY_MAIL_PK]: {
    carrier: SupportedCarrier.CITY_MAIL_PK,
    displayName: "CityMail PK",
    slug: "city_mail_pk",
    primaryProvider: {
      provider: TrackingProvider.TRACK123,
      carrierCode: "citymail-pk",
    },
  },
} as const satisfies Record<SupportedCarrier, CarrierDefinition>;

type CarrierRegistryConst = typeof _carrierRegistry;

export type CarrierRegistryDefinition = CarrierRegistryConst[SupportedCarrier];

export type CanonicalCarrierCode = CarrierRegistryDefinition["slug"];

// Re-export with general type for easier iteration while preserving const types above
export const carrierRegistry: Record<SupportedCarrier, CarrierDefinition> =
  _carrierRegistry;

export function getCanonicalCarrierCode(
  definition: CarrierDefinition,
): CanonicalCarrierCode {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return definition.slug as CanonicalCarrierCode;
}

// EasyPost provider carrier codes that EasyPost can only track with the
// merchant's own credentials — a team-independent property of the registry.
const credentialedEasypostCarrierCodes: ReadonlySet<string> = new Set(
  Object.values(carrierRegistry)
    .flatMap((definition) => [
      definition.primaryProvider,
      definition.secondaryProvider,
    ])
    .filter((provider) => provider != null)
    .filter(requiresEasypostCredentials)
    .map((provider) => provider.carrierCode),
);

// Whether tracking this carrier code needs the merchant's EasyPost credentials,
// before consulting any specific team (the codes are EasyPost's own).
export function carrierCodeRequiresEasypostCredentials(
  carrierCode: string | null | undefined,
): boolean {
  return (
    carrierCode != null && credentialedEasypostCarrierCodes.has(carrierCode)
  );
}
